export const QueryKeys = {
  features: 'features',
};
